import Loading from 'components/Loading';
import React, { useEffect } from 'react';
import { PRIMARY_GREEN } from 'resources/constants/colors';
import useConversations from 'state/conversations';
import useUser from 'state/user';
import styled from 'styled-components';
import ConversationsList from './components/ConversationsList';
import { UserTypes } from 'resources/constants/config';
import { NoMessagesState } from 'components/EmptyState';
import { MessageListItemSkeleton, SkeletonList } from 'components/Skeleton';
import SubpageTopBar from '../../components/SubpageTopBar';

const Title = styled.h1`
    margin: 0;
    font-size: 30px;
    font-weight: 600;
    color: ${PRIMARY_GREEN};
    text-align: center;
`;

const Notice = styled.span`
    margin: 0;
    margin-top: 20px;
    text-align: center;
`;

const ContentWrapper = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
`;

const Messages = ({ toggleMenu }) => {
    const [user] = useUser();
    const [conversations, conversationsDispatcher] = useConversations();

    useEffect(() => {
        conversationsDispatcher.fetchStart();
    }, []);

    // Filtrar conversaciones con interlocutor válido (usuarios no eliminados)
    const validConversations = conversations.list.filter(
        (c) => c.users && c.users.length > 0
    );

    return (
        <>
            <SubpageTopBar toggleMenu={toggleMenu} title="Mensajes" />
            <ContentWrapper>
                {conversations.fetching.fetch.state ? (
                    <SkeletonList
                        count={5}
                        component={MessageListItemSkeleton}
                    />
                ) : validConversations.length === 0 ? (
                    <NoMessagesState />
                ) : (
                    <ConversationsList list={validConversations} />
                )}
            </ContentWrapper>
        </>
    );
};

export default Messages;
